import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ClientEquipmentBidirecional from "../../components/ClientEquipmentBidirecional/ClientEquipmentBidirecional";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import { MaintenancePlanNavBar } from "../../components/MaintenancePlans/MaintenancePlanNavBar";
import SelectComponent from "../../components/SelectComponent";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { EquipmentDTO } from "../../models/Equipment/EquipmentDTO";
import { ReminderDTO } from "../../models/Reminder/ReminderDTO";
import { ReminderService } from "../../services/ReminderService";
import { ReminderNavBar } from "../../components/Reminders/ReminderNavBar";

export type SelectItemsProps = {
    label: string;
    value: string;
};

export default function ReminderDetails() {
    const intl = useIntl();
    const reminderService = new ReminderService();
    const [reminder, setReminder] = useState<ReminderDTO>({} as ReminderDTO);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { id } = useParams<{ id: string }>();

    // props para novo componente bidirecional (cliente-equipamento)
    const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
    const [projectSelected, setProjectSelected] = useState<SelectItemsProps | null>(null);
    const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(null);
    const [serialNumberSelected, setSerialNumberSelected] = useState<SelectItemsProps | null>(null);
    const [equipment, setEquipment] = useState<EquipmentDTO>({} as EquipmentDTO);
    const [isSearchEquipmentLoading, setIsSearchEquipmentLoading] = useState<boolean>(false);
    const [carPlateSelected, setCarPlateSelected] = useState<SelectItemsProps | null>(null);


    // será navbar
    // const [reminderStatusHistories, setReminderStatusHistories] = useState<GetReminderStatusHistoriesDTO>({} as GetReminderStatusHistoriesDTO);


    const GetReminder = async () => {
        setIsLoading(true);
        var response = await reminderService.GetById(Number(id));
        if (response.success === false || response.obj == null) {
            setIsLoading(false);
            Toast.Show("error", response.message);
            return;
        }
        setReminder(response.obj);
        setIsLoading(false);
    };
    useEffect(() => {
        GetReminder();
    }, []);


    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="col">
                        <PageTitle
                            title={intl.formatMessage({ id: 'Screens.Reminder.Details.Title' })}
                            allowGoBack={true}
                            dynamicTitle={() => `${intl.formatMessage({ id: 'Screens.Reminder.Details.Title' })} - ${reminder?.reminderDate ?
                                Utilities.formatDate(new Date(reminder?.reminderDate)) : 'Data formato incorreto'}`}
                        />
                    </div>
                </div>


                <div className="pageBody">
                    <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-start", alignContent: "flex-start", display: "flex", flexDirection: "row" }}>
                        <Col xl={6} lg={12} md={12} sm={12} xs={12}>

                            <label style={{ margin: "13px" }}>
                                <b>{intl.formatMessage({ id: "Screens.Reminder.Details.MaintenancePlanData" })}</b>
                            </label>

                            <ClientEquipmentBidirecional
                                isActiveProjectModule={isActiveProjectModule}
                                projectSelected={projectSelected}
                                clientSelected={clientSelected}
                                setClientSelected={setClientSelected}
                                serialNumberSelected={serialNumberSelected}
                                setSerialNumberSelected={setSerialNumberSelected}
                                equipment={equipment}
                                setEquipment={setEquipment}
                                isSearchEquipmentLoading={isSearchEquipmentLoading}
                                setIsSearchEquipmentLoading={setIsSearchEquipmentLoading}

                                clientErpId={reminder?.clientErpId}
                                equipmentErpId={reminder?.equipmentErpId}

                                isDisabled={true}

                                isActiveSearchByCarPlate={false}
                                carPlateSelected={carPlateSelected}
                                setCarPlateSelected={setCarPlateSelected}
                                disableSoftwareFields={true}
                            />
                            <Row
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    alignItems: "flex-end",
                                    alignContent: "flex-end",
                                }}
                            >
                                <InputComponent
                                    xl={2}
                                    lg={3}
                                    md={3}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.maintenancePlanNumerator}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.MaintenancePlanNumerator" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                                <InputComponent
                                    xl={8}
                                    lg={8}
                                    md={8}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.maintenancePlanName}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.MaintenancePlanName" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                                <InputComponent
                                    xl={2}
                                    lg={3}
                                    md={3}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"date"}
                                    value={reminder?.maintenancePlanStartDate ? Utilities.formatDateYYYYMMDD(new Date(reminder?.maintenancePlanStartDate)) : ''}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.StartDate" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                            </Row>

                            <Row
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    alignItems: "flex-end",
                                    alignContent: "flex-end",
                                }}
                            >
                                <InputComponent
                                    xl={3}
                                    lg={3}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.periodicityType}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.PeriodicityType" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />

                                <InputComponent
                                    xl={3}
                                    lg={3}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"number"}
                                    value={reminder?.periodicityRecurrence}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.PeriodicityRecurrence" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />

                                <InputComponent
                                    xl={3}
                                    lg={3}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.periodicityWeekNumber}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.PeriodicityWeekNumber" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />

                                <InputComponent
                                    xl={3}
                                    lg={3}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.periodicityDayOfWeek}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.PeriodicityDayOfWeek" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                            </Row>

                            <Row
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    alignItems: "flex-end",
                                    alignContent: "flex-end",
                                }}
                            >
                                <SelectComponent
                                    xl={4}
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.LocationType" })}
                                    selectedItemValue={reminder?.maintenancePlanLocationType}
                                    items={[]}
                                    onChange={(t: string) => {
                                    }}
                                    blockItem={true}
                                    showLoadingSkeleton={isLoading}
                                />
                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"number"}
                                    value={reminder?.maintenancePlanExpectedHours}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.ExpectedHours" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.maintenancePlanStatus}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.Status" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                            </Row>

                            <Row
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    alignItems: "flex-end",
                                    alignContent: "flex-end",
                                }}
                            >
                                <InputComponent
                                    xl={12}
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%", height: "120px" }}
                                    type={"textArea"}
                                    value={reminder?.maintenancePlanNotes}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.Notes" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                            </Row>
                            <Row
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    alignItems: "flex-end",
                                    alignContent: "flex-end",
                                }}
                            >
                                {/* <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"date"}
                                    value={reminder?.reminderDate}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.ReminderDate" })}
                                    readOnly={true}
                                /> */}

                                <label style={{ margin: "13px 0px" }}>
                                    <b>{intl.formatMessage({ id: "Screens.Reminder.Details.ReminderData" })}</b>
                                </label>

                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"date"}
                                    value={reminder?.reminderDate ? Utilities.formatDateYYYYMMDD(new Date(reminder?.reminderDate)) : ''}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.ReminderDate" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.reminderDayOfWeek}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.ReminderDayOfWeek" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={reminder?.reminderStatus}
                                    label={intl.formatMessage({ id: "Screens.Reminder.Details.LastReminderStatus" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />

                                {reminder?.reminderStatus === "CANCELADO" && (
                                    <InputComponent
                                        xl={12}
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        style={{ width: "100%" }}
                                        type={"textArea"}
                                        value={reminder?.cancellationReason || ""}
                                        label={intl.formatMessage({ id: "Screens.Reminder.Details.CancellationReason" })}
                                        readOnly={true}
                                        showLoadingSkeleton={isLoading}
                                    />
                                )}
                            </Row>
                        </Col>

                        <Col xl={6} lg={12} md={12} sm={12} xs={12}>
                            <ReminderNavBar reminderAssistanceNumber={reminder?.reminderAssistanceNumber} />
                        </Col>
                    </Row>
                </div>
            </div >
        </Layout >
    );
}